// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Modal,
//   Form,
//   Table,
//   Spinner,
// } from 'react-bootstrap';
// import { FaSearch, FaTrash } from 'react-icons/fa';
// import { Pencil } from 'lucide-react';
// import Swal from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';

// const API_URL = 'https://kaasbackend.vetrinahealthcare.com/lms/categories/';

// const CategoryPage = () => {
//   const [categories, setCategories] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [categoryInput, setCategoryInput] = useState('');
//   const [editItem, setEditItem] = useState(null);
//   const [isPageLoading, setIsPageLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isDeletingId, setIsDeletingId] = useState(null);

//   const token = localStorage.getItem('jwttoken');

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     setIsPageLoading(true);
//     try {
//       const res = await fetch(API_URL, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) {
//         const error = await res.json();
//         Swal.fire('Error', error.detail || 'Failed to fetch categories', 'error');
//         return;
//       }

//       const data = await res.json();
//       setCategories(data);
//     } catch (err) {
//       console.error(err);
//       Swal.fire('Error', 'Network error', 'error');
//     } finally {
//       setIsPageLoading(false);
//     }
//   };

//   const handleShowModal = () => {
//     setCategoryInput('');
//     setEditItem(null);
//     setShowModal(true);
//   };

//   const handleClose = () => {
//     setCategoryInput('');
//     setEditItem(null);
//     setShowModal(false);
//   };

//   const handleAddOrUpdate = async () => {
//     const trimmed = categoryInput.trim();
//     if (!trimmed) return;

//     setIsLoading(true);

//     if (editItem) {
//       // PATCH
//       try {
//         const res = await fetch(`${API_URL}${editItem.id}/`, {
//           method: 'PATCH',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to update', 'error');
//           return;
//         }

//         Swal.fire('Updated!', 'Category updated successfully.', 'success');
//         fetchCategories();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     } else {
//       // POST
//       try {
//         const res = await fetch(API_URL, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to add category', 'error');
//           return;
//         }

//         Swal.fire('Added!', 'Category added successfully.', 'success');
//         fetchCategories();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleEdit = (category) => {
//     setCategoryInput(category.name);
//     setEditItem(category);
//     setShowModal(true);
//   };

//   const handleDelete = async (category) => {
//     const confirm = await Swal.fire({
//       title: 'Are you sure?',
//       text: `Delete "${category.name}"?`,
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     });

//     if (confirm.isConfirmed) {
//       setIsDeletingId(category.id);

//       try {
//         const res = await fetch(`${API_URL}${category.id}/`, {
//           method: 'DELETE',
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to delete', 'error');
//           return;
//         }

//         Swal.fire('Deleted!', 'Category deleted successfully.', 'success');
//         fetchCategories();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsDeletingId(null);
//       }
//     }
//   };

//   const filteredCategories = categories.filter((cat) =>
//     cat.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div>
//       <h4 className="mb-3 text-center">Manage Categories</h4>

//       <div className="d-flex justify-content-between mb-3">
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             position: 'relative',
//             width: '300px',
//           }}
//         >
//           <FaSearch
//             style={{
//               position: 'absolute',
//               left: '10px',
//               color: '#888',
//             }}
//           />
//           <input
//             type="text"
//             placeholder="Search Category..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               padding: '8px 10px 8px 35px',
//               border: '1px solid #ddd',
//               borderRadius: '5px',
//               width: '100%',
//             }}
//           />
//         </div>

//         <Button
//           onClick={handleShowModal}
//           style={{
//             background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//             color: 'white',
//             border: 'none',
//           }}
//         >
//           + Add Category
//         </Button>
//       </div>

//       {isPageLoading ? (
//         <div className="text-center my-5">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <Table striped hover responsive>
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Category</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredCategories.length > 0 ? (
//               filteredCategories.map((cat) => (
//                 <tr key={cat.id}>
//                   <td>{cat.id}</td>
//                   <td>{cat.name}</td>
//                   <td>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#7366ff',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleEdit(cat)}
//                     >
//                       <Pencil size={20} />
//                     </Button>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#ff5370',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleDelete(cat)}
//                       disabled={isDeletingId === cat.id}
//                     >
//                       {isDeletingId === cat.id ? (
//                         <Spinner size="sm" animation="border" />
//                       ) : (
//                         <FaTrash size={20} />
//                       )}
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center">
//                   No categories found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       <Modal show={showModal} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{editItem ? 'Edit' : 'Add'} Category</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form.Control
//             type="text"
//             placeholder="Enter category name"
//             value={categoryInput}
//             onChange={(e) => setCategoryInput(e.target.value)}
//           />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             style={{
//               background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//               color: 'white',
//               border: 'none',
//             }}
//             onClick={handleAddOrUpdate}
//             disabled={isLoading}
//           >
//             {isLoading ? (
//               <Spinner size="sm" animation="border" />
//             ) : (
//               editItem ? 'Update Category' : 'Add Category'
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default CategoryPage;


import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Table,
  Spinner,
  Pagination,
} from 'react-bootstrap';
import { FaSearch, FaTrash } from 'react-icons/fa';
import { Pencil } from 'lucide-react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const API_URL = 'https://kaasbackend.vetrinahealthcare.com/lms/categories/';

const CategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [categoryInput, setCategoryInput] = useState('');
  const [editItem, setEditItem] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeletingId, setIsDeletingId] = useState(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const token = localStorage.getItem('jwttoken');

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setIsPageLoading(true);
    try {
      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const error = await res.json();
        Swal.fire('Error', error.detail || 'Failed to fetch categories', 'error');
        return;
      }

      const data = await res.json();
      setCategories(data);
      setCurrentPage(1); // Reset to first page when data changes
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Network error', 'error');
    } finally {
      setIsPageLoading(false);
    }
  };

  // Filter categories based on search term
  const filteredCategories = categories.filter((cat) =>
    cat.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCategories.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleShowModal = () => {
    setCategoryInput('');
    setEditItem(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setCategoryInput('');
    setEditItem(null);
    setShowModal(false);
  };

  const handleAddOrUpdate = async () => {
    const trimmed = categoryInput.trim();
    if (!trimmed) return;

    setIsLoading(true);

    if (editItem) {
      // PATCH
      try {
        const res = await fetch(`${API_URL}${editItem.category_id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to update', 'error');
          return;
        }

        Swal.fire('Updated!', 'Category updated successfully.', 'success');
        fetchCategories();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    } else {
      // POST
      try {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to add category', 'error');
          return;
        }

        Swal.fire('Added!', 'Category added successfully.', 'success');
        fetchCategories();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleEdit = (category) => {
    setCategoryInput(category.name);
    setEditItem(category);
    setShowModal(true);
  };

  const handleDelete = async (category) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete "${category.name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      setIsDeletingId(category.category_id);

      try {
        const res = await fetch(`${API_URL}${category.category_id}/`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to delete', 'error');
          return;
        }

        Swal.fire('Deleted!', 'Category deleted successfully.', 'success');
        fetchCategories();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsDeletingId(null);
      }
    }
  };

  return (
    <div>
      <h4 className="mb-3 text-center">Manage Categories</h4>

      <div className="d-flex justify-content-between mb-3">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: '300px',
          }}
        >
          <FaSearch
            style={{
              position: 'absolute',
              left: '10px',
              color: '#888',
            }}
          />
          <input
            type="text"
            placeholder="Search Category..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '8px 10px 8px 35px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              width: '100%',
            }}
          />
        </div>

        <Button
          onClick={handleShowModal}
          style={{
            background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
            color: 'white',
            border: 'none',
          }}
        >
          + Add Category
        </Button>
      </div>

      {isPageLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="warning" />
        </div>
      ) : (
        <>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Category</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((cat, index) => (
                  <tr key={cat.category_id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{cat.name}</td>
                    <td>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#7366ff',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleEdit(cat)}
                      >
                        <Pencil size={20} />
                      </Button>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#ff5370',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleDelete(cat)}
                        disabled={isDeletingId === cat.category_id}
                      >
                        {isDeletingId === cat.category_id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          <FaTrash size={20} />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No categories found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          {filteredCategories.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination>
                <Pagination.First 
                  onClick={() => paginate(1)} 
                  disabled={currentPage === 1} 
                />
                <Pagination.Prev 
                  onClick={() => paginate(currentPage - 1)} 
                  disabled={currentPage === 1} 
                />
                
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => paginate(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                
                <Pagination.Next 
                  onClick={() => paginate(currentPage + 1)} 
                  disabled={currentPage === totalPages} 
                />
                <Pagination.Last 
                  onClick={() => paginate(totalPages)} 
                  disabled={currentPage === totalPages} 
                />
              </Pagination>
            </div>
          )}
        </>
      )}

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editItem ? 'Edit' : 'Add'} Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            placeholder="Enter category name"
            value={categoryInput}
            onChange={(e) => setCategoryInput(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{
              background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
              color: 'white',
              border: 'none',
            }}
            onClick={handleAddOrUpdate}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              editItem ? 'Update Category' : 'Add Category'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CategoryPage;